import { render, staticRenderFns } from "./TVConfigAPIKey.vue?vue&type=template&id=72219f2a&scoped=true"
import script from "./TVConfigAPIKey.vue?vue&type=script&lang=js"
export * from "./TVConfigAPIKey.vue?vue&type=script&lang=js"
import style0 from "./TVConfigAPIKey.vue?vue&type=style&index=0&id=72219f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72219f2a",
  null
  
)

export default component.exports